import { mapState as rootMapState } from 'pinia';
import { usePageStore } from '@/store';
import { mapState } from '@/store/helpers';
import { getSearchTagMixin } from './_center-adaptor';
import util from '../../common/util';
export default function({ searchCenter, expand = false }) {
    return {
        emits: ['update'],
        i18next: {
            ns: 'md-search-bar'
        },
        mixins: [getSearchTagMixin(searchCenter)],
        props: [
            'collapse',
            'filter',
            'simple',
            'hideRemoveAll',
            'inMore',
            'outSideSuggestion'
        ],
        data: function() {
            return {
                hideCount: 0,
                expand
            };
        },
        computed: {
            ...rootMapState(usePageStore, ['forCMS']),
            ...mapState([
                'conditionSort',
                'keywords',
                'conditions',
                'mapCondition',
                'allConditions'
            ]),
            isMobileSize() {
                return this.platform.isMobile;
            },
            tagCount() {
                return this.filteredTagList.length;
            },
            hasTag() {
                return this.filteredTagList.length > 0;
            }
        },
        watch: {
            collapse() {
                this.collapseTags();
            },
            filteredTagList() {
                this.collapseTags();
            },
            tagCount: {
                immediate: true,
                handler: function() {
                    this.$emit('update', this.tagCount);
                }
            },
        },
        methods: {
            //  For mobile 
            toggleExpand() {
                this.expand = !this.expand;
            },
            removeAll() {
                this.filteredTagList.forEach(tag => this.removeTag(tag));
            },
            //  to hide some labels 
            //  select multiple tag hour ， there will be no newline 
            // collapse for true hour ， turn on 
            collapseTags() {
                this.hideCount = 0;
                if (!this.collapse && !this.forCMS) {
                    return;
                }
                let self = this;
                function doCollapse() {
                    self.$nextTick(() => {
                        if (
                            !util.isSSRServer &&
                            self.$refs.tags.scrollHeight > 40 &&
                            self.hideCount < self.filteredTagList.length - 1
                        ) {
                            self.hideCount++;
                            doCollapse();
                        }
                    });
                }
                doCollapse();
            }
        },
        mounted() {
            if (this.collapse) {
                this.collapseTags();
            }
        }
    };
}
